export const extractFiltersQuery = (filters = {}) => {
  /* eslint-disable-line */
  return Object.keys(filters)
    .filter(filterName => filters[filterName])
    .map(filterName => `&${filterName}=${encodeURIComponent(filters[filterName])}`)
    .join('');
};
